import axios, { AxiosHeaders, AxiosRequestConfig, AxiosResponse, RawAxiosRequestHeaders } from "axios";

import { ConfigurationProvider } from '../configuration/ConfigurationProvider';
import { IdentityService } from "../identity/IdentityService";
import { v4 as uuidv4 } from 'uuid';

export function getSessionId() : string | null {
  const sessionStoreName = `${ConfigurationProvider.getConfiguration().App.Name}-SessionId`;

  if(!sessionStorage.getItem(sessionStoreName)) {
    sessionStorage.setItem(sessionStoreName, uuidv4())
  }

  return sessionStorage.getItem(sessionStoreName);
}

function initHeaders(config: AxiosRequestConfig, headerFunc?: (headers: (RawAxiosRequestHeaders) | AxiosHeaders) => void){
  if (!config.headers) {
    config.headers = {
    };
  }

  config.headers["AURORA_SESSION_ID"] = getSessionId();

  if(headerFunc) headerFunc(config.headers);
}

interface HttpClientOptions {
  correlationId?: string | null ;
}

export class HttpClient {
  static sessionRequest<T = any>(config: AxiosRequestConfig & HttpClientOptions): Promise<AxiosResponse<T>> {

    return IdentityService.Global.getAccessToken().then((accessToken) => {
      let requestOptions = { ...config };

      initHeaders(requestOptions, headers => {
        if (accessToken) {
           headers["Authorization"] = `Bearer ${accessToken}`;
        }

        if(config.correlationId) {
          headers["AURORA_CORRELATION_ID"] = config.correlationId;
        }
      });

      return axios.request<T>({ ...requestOptions });
    });
  }

  static request<T = any>(config: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    let requestOptions = { ...config };

    initHeaders(requestOptions);

    return axios.request<T>({ ...requestOptions });
  }
}
